import type { ActivityEventType, ActivityResource } from "@/types/fleet";

/**
 * The runtime allowlists behind `ActivityEventType` / `ActivityResource`.
 *
 * Kept in their own module because both ends need them: the proxy handler validates an incoming
 * batch against these before forwarding (the browser does not get to invent event types), and the
 * client reader narrows upstream strings with them. Importing the browser client into a route
 * handler just to reach a tuple would drag `apiRequest` onto the server for no reason.
 */

export const ACTIVITY_EVENT_TYPES = [
  "login",
  "logout",
  "page_view",
  "report_generate",
  "history_query",
  "export_pdf",
  "export_excel",
  "export_map_pdf",
  "create",
  "update",
  "delete",
] as const satisfies readonly ActivityEventType[];

export const ACTIVITY_RESOURCES = [
  "session",
  "page",
  "report",
  "history",
  "vehicle",
  "driver",
  "zone",
  "poi",
  "group",
  "user",
  "cost",
  "cost_category",
  "cost_recurrence",
] as const satisfies readonly ActivityResource[];
